import Storage from 'common/resource/ObjectStorage';

import {
  type CountryCode,
  type CharityVettingFormValues,
  type CharityVettingUrlTypeValues,
  type LocalisedFlowProgress,
} from '../types/charityVettingTypes';

type CurrentFlowStatus = Partial<Record<CharityVettingUrlTypeValues, boolean>>;

const getCharityVettingUserEmail = (): { userEmail: string } =>
  new Storage(window.localStorage, 'myStore:charityVetting:userEmail').get();

export const setCharityVettingUserEmail = (userEmail: string) =>
  new Storage(window.localStorage, 'myStore:charityVetting:userEmail').set({ userEmail });

export const getCharityVettingFlowStatus = (): LocalisedFlowProgress => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  return new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:flowStatus`).get();
};

export const setCharityVettingFlowStatus = (currentFlowStatus: CurrentFlowStatus) => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  const flowStatus = getCharityVettingFlowStatus() ?? undefined;
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:flowStatus`).set({
    ...flowStatus,
    ...currentFlowStatus,
  });
};

export const getCharityVettingFormValues = (): CharityVettingFormValues['charityOnboarding'] => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  return new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:formValues`).get();
};

export const setCharityVettingFormValues = (
  formValues: CharityVettingFormValues['charityOnboarding'],
) => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:formValues`).set(
    formValues,
  );
};

export const getCountryCodeFromStorage = (): CountryCode | null =>
  getCharityVettingFormValues()?.countryIsoCode ?? null;

// Guards the one-time `start` call (charity creation) so it fires only once per
// wizard, even across back-navigation and re-submits of the contact step.
export const getCharityStarted = (): boolean => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  return !!new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:started`).get<{
    started?: boolean;
  }>()?.started;
};

export const setCharityStarted = () => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:started`).set({
    started: true,
  });
};

export const clearCharityVettingStorage = () => {
  const userEmail = getCharityVettingUserEmail()?.userEmail;
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:formValues`).clear();
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:flowStatus`).clear();
  new Storage(window.localStorage, `myStore:charityVetting:${userEmail}:started`).clear();
  new Storage(window.localStorage, 'myStore:charityVetting:userEmail').clear();
};
